import { appErrorAction } from '../actions/App';

/**
 * Throws a generic error that will cause the app to show generic error page.
 * @param  {object} errorData The data describing the error.
 * @param  {function} dispatch The action dispatch function from the store.
 */
export const throwGenericError = (errorData, dispatch) => {
  const error = {
    errorType: 'generic',
    errorData,
  };
  dispatch(appErrorAction(error));
};

export const createErrorBody = (errorMsg, ...errorData) => {
  return {
    message: errorMsg,
    errorData,
  };
};

const handle400Code1111 = (data, errorConfig, isCalculatingPrice, isPurchase) => {
  if (errorConfig[data.code]) {
    if (isCalculatingPrice && errorConfig[data.code].calcPriceOverride) {
      return errorConfig[data.code].calcPriceOverride;
    }
    if (isPurchase && errorConfig[data.code].purchaseOverride) {
      return errorConfig[data.code].purchaseOverride;
    }
    return errorConfig[data.code];
  }
  if (isCalculatingPrice && errorConfig.general.calcPriceOverride) {
    return errorConfig.general.calcPriceOverride;
  }
  if (isPurchase && errorConfig.general.purchaseOverride) {
    return errorConfig.general.purchaseOverride;
  }
  return errorConfig.general;
};

const handle400 = (data, errorConfig, isCalculatingPrice, isPurchase) => {
  // We'll only handle the first error.
  if (typeof data === 'object') {
    const { errors: [error] } = data;
    switch (error.code) {
      case 1111:
        return handle400Code1111(error.service, errorConfig, isCalculatingPrice, isPurchase);
      default:
        return errorConfig.general;
    }
  }
  return errorConfig.general;
};

const handle422 = (data, errorConfig) => {
  // We'll only handle the first error.
  if (typeof data === 'object') {
    const { errors: [error] } = data;
    switch (error.code) {
      default:
        return errorConfig.general;
    }
  }
  return errorConfig.general;
};

export const getErrorProps = (
  errorObject,
  errorConfig,
  debugServices,
  debugErrors,
  isCalculatingPrice,
  isPurchase
) => {
  if (!errorObject.response) {
    return errorConfig.general;
  }

  const { response: { status, data } } = errorObject;

  if (debugErrors) {
    console.warn(`Service failed with status: ${status}`, data.errors); /* eslint-disable-line */
  }

  switch (status) {
    case 400:
      return handle400(data, errorConfig, isCalculatingPrice, isPurchase);
    case 422:
      return handle422(data, errorConfig);
    default:
      return errorConfig.general;
  }
};

const getGenericErrorTracking = () => {
  return {
    'error_type': 'system error',
    'error_code': 'Not available',
    'error_message': 'Not available',
  };
};

const getErrorTrackingData = (data) => {
  if (!data.errors) {
    return getGenericErrorTracking();
  }
  const errors = data.errors.filter(error => error.service);

  // Return first service error.
  if (errors.length) {
    const error = errors[0];
    return {
      'error_type': error.service.type,
      'error_code': error.service.code,
      'error_message': error.service.message,
    };
  }

  // Found no service error.
  return getGenericErrorTracking();
};

export const setErrorTracking = (errorObject) => {
  /* global Drupal */
  // Let track the error.
  let error;
  if (!errorObject.response) {
    error = getGenericErrorTracking();
  } else {
    const { response: { data } } = errorObject;
    error = getErrorTrackingData(data);
  }
  if (typeof Drupal !== 'undefined' && Drupal.behaviors && Drupal.behaviors.trygTealium) {
    // Let reset hash so the error will be sent.
    Drupal.behaviors.trygTealium.hash = 'error';
    Drupal.behaviors.trygTealium.flowError = error;
  }
};



// WEBPACK FOOTER //
// ./src/utilities/error.js